import api from '../../../../services/api';

const SCREENSHOT_URL_ENDPOINT = '/umbraco/api/PreSignedImage/GetPresignedUrlByKey';

export const getPresignedScreenshotUrl = async (key: string): Promise<string | null> => {
  const response = await api.get<unknown>(SCREENSHOT_URL_ENDPOINT, {
    params: { key },
  });

  return typeof response.data === 'string' && response.data.trim() ? response.data : null;
};
